import { render, staticRenderFns } from "./SuccessMsg.vue?vue&type=template&id=4824c587&"
import script from "./SuccessMsg.vue?vue&type=script&lang=js&"
export * from "./SuccessMsg.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports